import React, { useState } from "react";
import LabelInput from "../../common/LabelInput";
import Body from "../../components/Body";
import { RiBankFill, RiPhoneFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import { BiPlus, BiCheckCircle } from "react-icons/bi";
import colors from "../../config/colors";
import AppButton from "../../common/AppButton";
import _, { cloneDeep } from "lodash";
import api from "../../config/api";
import IconButton from "../../common/IconButton";
import DetailBlock from "../../common/DetailBlock";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const size = 25;
const formInit = {
  name: "",
  email: "",
  phone: "",
  billingAddress: "",
  locations: [
    {
      title: "",
    },
  ],
};
export default function OrganizationCreate() {
  const queryClient = useQueryClient();

  const [form, setForm] = useState(_.cloneDeep(formInit));
  const navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault();
    const res = await api.post("organizations", {
      ...form,
      locations: form.locations.filter((i) => i.title),
    });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["organizations"]);

    toast.success("Organization has been successfully created !");

    return navigate(-1);
  };
  const handleChange = ({ target: currentTarget }) => {
    const name = currentTarget.name;
    const value = currentTarget.value;
    setForm({ ...form, [name]: value });
  };
  const { name, email, phone, billingAddress } = form;
  const newLocation = () => {
    setForm({
      ...form,
      locations: [...form.locations, cloneDeep(formInit.locations[0])],
    });
  };
  const handleLocationChange = ({ currentTarget }, ind) => {
    const value = currentTarget.value;
    const name = currentTarget.name;
    const locations = [...form.locations];
    locations[ind][name] = value;
    setForm({ ...form, locations });
  };

  return (
    <Body back title="Create">
      {/* <form onSubmit={handleSubmit}> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        <div style={{ width: "100%" }}>
          <DetailBlock style={{ padding: 40 }}>
            <div className="d-flex " style={{ gap: 40 }}>
              <LabelInput
                onChange={handleChange}
                leftIcon={<RiBankFill size={size} color={colors.silver} />}
                placeholder="Name"
                name="name"
                value={name}
                required
              />
              <LabelInput
                onChange={handleChange}
                leftIcon={<MdEmail size={size} color={colors.silver} />}
                placeholder="Email"
                name="email"
                inputType="email"
                value={email}
              />
              <LabelInput
                onChange={handleChange}
                leftIcon={<RiPhoneFill size={size} color={colors.silver} />}
                placeholder="Phone"
                name="phone"
                value={phone}
                inputType="text"
              />
            </div>
            <div className="d-flex ">
              <LabelInput
                containerStyle={{
                  width: 800,
                  maxWidth: "100%",
                }}
                style={{ maxWidth: "100%" }}
                leftIcon={<IoLocationSharp size={size} color={colors.silver} />}
                placeholder="Billing Address"
                onChange={handleChange}
                name="billingAddress"
                value={billingAddress}
                required
              />
            </div>
            <div className="d-flex " style={{ marginBottom: 10 }}>
              {form.locations.length === 1 && (
                <div
                  className="d-flex"
                  style={{ justifyContent: "space-between", width: 800 }}
                >
                  <LabelInput
                    name="tag"
                    value={form.locations[0].tag || ""}
                    onChange={(event) => {
                      handleLocationChange(event, 0);
                    }}
                    leftIcon={
                      <IoLocationSharp size={size} color={colors.silver} />
                    }
                    placeholder="Title"
                  />
                  <LabelInput
                    containerStyle={{
                      width: 520,
                      maxWidth: "100%",
                    }}
                    style={{ maxWidth: "100%" }}
                    leftIcon={
                      <IoLocationSharp size={size} color={colors.silver} />
                    }
                    name="title"
                    placeholder="Location"
                    type="text"
                    value={form.locations[0].title || ""}
                    required
                    onChange={(event) => {
                      handleLocationChange(event, 0);
                    }}
                    rightComponent={
                      <IconButton
                        onClick={newLocation}
                        icon={<BiPlus size={size} />}
                      />
                    }
                  />
                </div>
              )}

              <div>
                {form.locations.length > 1 &&
                  form.locations.map((loc, ind) => {
                    const last = ind + 1 === form.locations.length;
                    return (
                      <div
                        key={String(ind)}
                        className="d-flex"
                        style={{
                          justifyContent: "space-between ",
                          width: 800,
                        }}
                      >
                        <LabelInput
                          autoFocus={last}
                          name="tag"
                          placeholder="Title"
                          value={loc.tag || ""}
                          onChange={(event) => {
                            handleLocationChange(event, ind);
                          }}
                        />
                        <LabelInput
                          containerStyle={{
                            width: 520,
                            maxWidth: "100%",
                          }}
                          style={{ maxWidth: "100%" }}
                          leftIcon={
                            <IoLocationSharp
                              size={size}
                              color={colors.silver}
                            />
                          }
                          value={loc.title || ""}
                          name="title"
                          onChange={(event) => {
                            handleLocationChange(event, ind);
                          }}
                          placeholder="Location"
                          rightComponent={
                            <React.Fragment>
                              {last && (
                                <IconButton
                                  onClick={newLocation}
                                  icon={<BiPlus size={size} />}
                                />
                              )}
                            </React.Fragment>
                          }
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </DetailBlock>
        </div>
        <AppButton
          style={{ margin: "10px 0px" }}
          onClick={handleSubmit}
          type="submit"
          leftIcon={<BiCheckCircle size={20} />}
          text="Create"
          className="btn-primary"
        />
      </div>
      {/* </form> */}
    </Body>
  );
}
